import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

export default function NoResultInSearch({ customCss }) {
  const { t } = useTranslation()
  return <div className={`${styles.container} ${customCss}`}>{t('messenger.noresultInSearch')}</div>
}
